import { roundMoneyAmount } from "./Utils";

export type TvaCalculationMode = "HT" | "TTC";

export type ShopTvaSettings = {
  tva_enabled?: boolean | null;
  tva_rate?: number | string | null;
  tva_calculation_mode?: TvaCalculationMode | string | null;
};

export const DEFAULT_TVA_RATE = 18;

/** TVA désactivée par défaut ; activée seulement si tva_enabled === true. */
export function isShopTvaEnabled(
  settings?: ShopTvaSettings | null,
): boolean {
  return settings?.tva_enabled === true;
}

/** TVA active et prix saisis hors taxe → affichage client en TTC. */
export function shouldShowPricesAsTtc(
  settings?: ShopTvaSettings | null,
): boolean {
  if (!settings || !isShopTvaEnabled(settings)) return false;
  const mode = (settings.tva_calculation_mode ?? "HT").toString().toUpperCase();
  return mode === "HT";
}

export function getShopTvaRate(settings?: ShopTvaSettings | null): number {
  const raw = settings?.tva_rate;
  const n = raw != null ? Number(raw) : DEFAULT_TVA_RATE;
  if (!Number.isFinite(n) || n <= 0) return DEFAULT_TVA_RATE;
  return n;
}

/**
 * Prix affiché au client sur le site / catalogue.
 * HT + TVA active → TTC ; sinon inchangé.
 */
export function toCustomerDisplayPrice(
  amount: number,
  settings?: ShopTvaSettings | null,
): number {
  const base = roundMoneyAmount(amount);
  if (!shouldShowPricesAsTtc(settings)) return base;
  const rate = getShopTvaRate(settings) / 100;
  return roundMoneyAmount(base * (1 + rate));
}

export function toShopTvaSettings(
  vendeur?: ShopTvaSettings | null,
): ShopTvaSettings | undefined {
  if (!vendeur) return undefined;
  return {
    tva_enabled: vendeur.tva_enabled,
    tva_rate: vendeur.tva_rate,
    tva_calculation_mode: vendeur.tva_calculation_mode as TvaCalculationMode,
  };
}
